import React, { useState, useEffect } from "react"
import { graphql, useStaticQuery, Link } from "gatsby"
import { GatsbyImage, getImage } from "gatsby-plugin-image"

export default function Header() {
  const data = useStaticQuery(graphql`
    query HeaderMenuQuery {
      datoCmsMenu {
        lhsMenuLinks {
          id
          title
          link
          image {
            gatsbyImageData
          }
        }
      }
    }
  `)
  const [bgActive, setBgActive] = useState(false)
  const links = data?.datoCmsMenu?.lhsMenuLinks || []
  const [activeLink, setActiveLink] = useState(null)
  useEffect(() => {
  const handleScroll = () => {
    if (window.innerWidth >= 768) return 

    const trigger = window.innerHeight  
    const scrolled = window.scrollY

    setBgActive(scrolled >= trigger)
  }

  window.addEventListener("scroll", handleScroll)
  return () => window.removeEventListener("scroll", handleScroll)
}, [])
  return (
    <>
      <header className='masthead-layer masthead-images'>
        <div className='common-grid grid p16'>
          <Left links={links} mode="images" activeLink={activeLink} />
          <div className='col-4' />
          <div className='col-1' />
          <div className='col-3' />
        </div>
      </header>
      <header className='masthead-layer masthead-text'>
        <div className='common-grid grid p16'>
          <Left links={links} mode="text" setActiveLink={setActiveLink} />
          <div className='col-4 flex justify-center'>
            <Link to='/'>
              <Logo />
            </Link>
          </div>
          <div className='col-1' />
          <Right />
        </div>
      </header>
      <div className={`header--bg ${bgActive ? "active" : ""}`} />
    </>
  )
}

const Logo = () => {
  return (
    <svg className='masthead-logo' viewBox="0 0 32 50" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path className='f' d="M1.08594 49.7057V28.0497H4.50396V45.5355H14.8424V31.195H18.2604V45.5355H31.7215V49.7057H1.08594Z" fill="white"/>
      <path className='g' d="M16.0367 26.2518C7.17517 26.2518 0.0859375 21.1028 0.0859375 12.2092C0.0859375 5.18794 4.05253 0.890065 9.62264 0.124107V4.42198C5.69825 5.14538 3.37737 8.039 3.37737 12.2092C3.37737 17.9539 8.4411 21.9113 16.0367 21.9113C23.6323 21.9113 28.5695 18.2943 28.5695 12.5496C28.5695 7.48581 24.6451 4.12411 18.9484 4.08155V11.656H15.4881V0.0390015H31.3545V3.69858H30.0886C29.2024 3.69858 28.2319 3.69858 27.4301 3.57092L27.3457 3.78368C30.2152 5.78368 31.8609 8.97517 31.8609 13.0177C31.8609 22.1667 24.8982 26.2518 16.0367 26.2518Z" fill="white"/>
    </svg>
  )
}


const Left = ({ links = [], mode, activeLink, setActiveLink }) => {
  return (
    <div className='col-4'>
      <div className='grid grid-4 m-hide'>
        {links.map(item => (
          <MenuLink key={item.id} id={item.id} title={item.title} link={item.link} image={item.image} mode={mode} isActive={activeLink === item.id} onMouseEnter={setActiveLink} onMouseLeave={() => setActiveLink && setActiveLink(null)} />
        ))}
      </div>
    </div>
  )
}

const MenuLink = ({ id, title, link, image, mode, isActive, onMouseEnter, onMouseLeave }) => {
  const img = image ? getImage(image) : null
  const isText = mode === "text"
  return (
    <div className={`menu-link pos-rel${isActive && !isText ? " active" : ""}`} onMouseEnter={() => isText && onMouseEnter(id)} onMouseLeave={() => isText && onMouseLeave()}>
      <Link data-title={title} className={`wh-link ${!isText ? "invisible" : ""}`}  activeClassName={isText ? "active" : ""}  to={link} tabIndex={isText ? 0 : -1}>
        {title}
      </Link>
      {!isText && img && (
        <div className='menu--image ratio-3-4 pos-rel'>
          <GatsbyImage image={img} alt={title} className='bg-image' />
        </div>
      )}
    </div>
  )
}


const Right = () => {
  const [menuOpen, setMenuOpen] = useState(false)
  const openContact = type => {
    window.dispatchEvent(new CustomEvent("open-contact-overlay", { detail: { type } }))
  }
  const toggleMenu = () => {
    document.body.classList.toggle('menu-open')
    setMenuOpen(prev => !prev)
  }
  return (
    <div className='flex col-3'>
      <div className='m-show mla'><p className='mobile-menu--button button' role='presentation' onClick={toggleMenu}>{menuOpen ? "Close" : "Menu"}</p></div>
      <div className='flex w-100 m-hide gap-48 justify-right'>
        <Link className='wh-link' data-title='Partners' activeClassName='active' to='/partners'>Partners</Link>
        <p className='wh-link pointer' role='presentation' onClick={() => openContact("trade")} activeClassName='active'>Trade</p>
        <p className='wh-link pointer' role='presentation' onClick={() => openContact("general")} activeClassName='active'>Contact</p>
      </div>
    </div>
  )
}